import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import { sample } from 'lodash';
export var colorUtils = {
  data: function data() {
    return {
      colorPalette: ['#ea0a8a', '#7eafd4', '#dbe123', '#12b57b', '#b04835', '#009edb', '#662d91', '#ba1f6b', '#f8b59b', '#4eb8b9', '#e11b22', '#21409a', '#f1668e', '#8dc63f', '#007c8e', '#ffdd00', '#b09bca', '#f37032', '#faa74a', '#8ed8f8']
    };
  },
  methods: {
    getRandomColor: function getRandomColor() {
      return sample(this.colorPalette);
    },
    hexToRgbComponents: function hexToRgbComponents(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      }); //

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    shadeColor: function shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);
      R = parseInt(R * (100 + percent) / 100);
      G = parseInt(G * (100 + percent) / 100);
      B = parseInt(B * (100 + percent) / 100);
      return '#' + this.numberToHex(R) + this.numberToHex(G) + this.numberToHex(B);
    },
    numberToHex: function numberToHex(number) {
      if (number > 255) number = 255;
      if (number < 0) number = 0;
      var hex = number.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    },
    adjustColorToRgb: function adjustColorToRgb(color, pct) {
      var myRgb = this.hexToRgbComponents(color);
      var newColor = {
        r: myRgb.r + parseInt(pct * (255 - myRgb.r) / 100),
        g: myRgb.g + parseInt(pct * (255 - myRgb.g) / 100),
        b: myRgb.b + parseInt(pct * (255 - myRgb.b) / 100)
      };
      return "rgb(".concat(newColor.r, ", ").concat(newColor.g, ", ").concat(newColor.b, ")");
    },
    textColorFromBackground: function textColorFromBackground(color) {
      var myRgb = this.hexToRgbComponents(color);
      return myRgb.r * 0.299 + myRgb.g * 0.587 + myRgb.b * 0.114 > 150 ? '#000' : '#fff';
    }
  }
};